import { useState, useCallback } from 'react';
import { useLoader } from '../contexts/LoaderContext';
import { useAlert } from '../contexts/AlertContext';
import { users } from '../api/users';

export const useUserActions = () => {
  const [selectedUsers, setSelectedUsers] = useState<number[]>([]);
  const [userIdToDelete, setUserIdToDelete] = useState<number | null>(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const { showLoader, hideLoader } = useLoader();
  const { showAlert } = useAlert();

  const handleDeleteUser = useCallback((userId: number) => {
    setUserIdToDelete(userId);
    setIsDeleteModalOpen(true);
  }, []);

  const handleDeleteAll = useCallback(() => {
    setUserIdToDelete(null);
    setIsDeleteModalOpen(true);
  }, []);

  const handleConfirmDelete = async (id?: number) => {
    try {
      showLoader();
      if (id) {
        await users.delete(id);
        showAlert('User successfully deleted', 'success');
      } else if (selectedUsers.length > 0) {
        await users.deleteMany(selectedUsers);
        showAlert('Users successfully deleted', 'success');
      } else {
        showAlert('No users selected for deletion', 'warning');
      }
    } catch (error: any) {
      showAlert(error.message || 'Failed to delete user(s)', 'error');
    } finally {
      hideLoader();
      setIsDeleteModalOpen(false);
      setUserIdToDelete(null);
      setSelectedUsers([]);
    }
  };

  return {
    selectedUsers,
    setSelectedUsers,
    userIdToDelete,
    isDeleteModalOpen,
    setIsDeleteModalOpen,
    handleDeleteUser,
    handleDeleteAll,
    handleConfirmDelete,
  };
};
